import React from 'react';

/**
 * Funkcja służąca to rozdzielenia tłumaczenia za pomocą '\n' (operatorem new line)
 * Zwraca kod JSX
 *
 * @param translation
 */
const translationNewLineSeparator = (translation: string, separator = '\n'): JSX.Element => (
  <React.Fragment>
    {translation.split(separator).map((item, idx) => (
      <>
        {idx !== 0 && <br />}
        {item}
      </>
    ))}
  </React.Fragment>
);

export default translationNewLineSeparator;
